module.exports = __webpack_public_path__ + "img/not-found.580e449b.svg";